import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import legend from '../../images/about/lazerUygulamalari.jpg';
import kilcal from '../../images/kozmetik/16001710716615.jpg';
import lazer from '../../images/kozmetik/1600170895478.jpg';
import leke from '../../images/kozmetik/16001713555310.jpg';
import yenileme from '../../images/kozmetik/1600171539267.jpg';

import '../../styles/subItem.css'

const VarisTedavisi = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='sub-page'>
            <Image src={legend} fluid className="subItemPage-img" />
            <Container>
                <Row className="mt-4">
                    <Col>
                        <h2>LAZERLE KILCAL DAMAR VE VARİS TEDAVİSİ</h2>
                        <hr />
                        <div className='image-frame'>
                            <Image src={kilcal} className='subitem-img' />
                        </div>
                        <p>Lazerle kılcal damar ve varis tedavisi, istenmeyen damarları ameliyatsız bir yöntemle ve lazer teknolojileri ile yok eden yeni tedavi biçimidir. Lazer tedavisi hızlı, pratik ve ağrısız bir şekilde kolaylıkla uygulanabilmektedir.</p>
                        <p>Kliniğimizde kılcal damar ve varis tedavisi FDA tarafından onaylı Nd:Yag lazerleri ile yapılmaktadır.</p>
                        <p>Lazerle varis tedavisi her hastanın lezyonlarına göre kişiye özel planlanmalıdır.Kliniğimizde bu amaçla FDA onaylı Nd:Yag lazeri kullanılmaktadır. Lezyona göre lazer enerjisinin dozu kişiye özel ayarlanır ve seans aralıkları bir kaç haftadan bir kaç aya kadar değişebilecek şekilde yine kişiye özel olarak planlanır. Lazerle damar tedavilerinde genellikle bir veya iki seans yeterlidir.Bazı durumlarda seans sayısı dörde kadar çıkabilir.2 seans arası ortalama 5-6 haftadır. Bununla beraber tedavi sayısı damarların sayısı, rengi ve büyüklüğüne göre değişebilir.</p>
                        <p>Tedavi uygulama süresi 15 dk ile 45 dk arasındadır. Tedavi öncesi ve sonrasında kan sulandırıcı aspirin gibi ilaçlar kullanılmamalıdır. İnce damarlarda sonuçlar anında ortaya çıkar. Daha geniş çaplı damarlarda ise sonuçların ortaya çıkması 1-2 ayı bulabilir.Tedavi sonrası varis çorabı giyilmesi önerilir.</p>
                        <p>Lazer tedavisi yüz ve bacağın her türlü bölgesinde rahatlıkla uygulanabilir. Kontakt sağutma özelliği nedeniyle acı hissi yoktur. Bazen hassas kişiler için krem olarak lokal anestezik ilaçlar kullanılabilir.</p>
                        <p>Lazerle damar tedavisinin önemli bir yan etkisi yoktur. İşlem sonrası geçici ödem ve kızarıklık olabilir.Tedavi sonrası güneşten korunmak önem taşır. Yan etkiler genellikle geçicidir.</p>
                    </Col>
                    <hr />
                </Row>
                <Row className='justify-content-md-start mt-3'>
                    <h2 className='mb-4'>Lazer Uygulamaları</h2>
                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/lazer-epilasyon" onClick={handleScrollToTop} >
                                <Card.Body>
                                    <p>LAZER EPİLASYON</p>
                                    <div className='card-image-frame'>
                                        <Image src={lazer} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/leke-tedavisi" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE LEKE TEDAVİSİ</p>
                                    <div className='card-image-frame'>
                                        <Image src={leke} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/cilt-yenileme" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE CİLT YENİLEME</p>
                                    <div className='card-image-frame'>
                                        <Image src={yenileme} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                </Row>
            </Container>
        </div>
    )
}

export default VarisTedavisi